import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import images from "../../../images";
import NewHeader from "../../Home/NewHeader";
import Button from "../../../components/common/Button/Button";
import { useTranslation } from "react-i18next";
import { useGetWithdrawDetailsQuery } from "../../../services/apiSlice";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";

const EarningWithdraw = ({ coin }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { withdrawId } = location.state || {};

  const { data: withdrawDetails, isLoading } = useGetWithdrawDetailsQuery({
    withdraw_id: withdrawId,
  });

  const handleBackToProfile = () => {
    navigate("/profile");
  };

  const handleWithdrawalHistory = () => {
    navigate("/profile/history");
  };

  return (
    <>
      <LoadingCommon isLoading={isLoading} />
      <div className="flex flex-col w-full h-screen bg-[#ECEEFF]">
        {/* Header */}
        <div className="flex-shrink-0 sticky top-0 left-0 w-full z-50">
          <NewHeader backgroundHeader="bg-[#ECEEFF]" />
        </div>

        <div className="flex-1 flex flex-col items-center justify-center px-[30px] min-h-0">
          <div className="flex flex-col items-center justify-center">
            <img
              src={images.Earning}
              alt="Earning Icon"
              className="w-[121px] h-[201.33px] mb-6"
            />
            <h1 className="text-[#253FF6] text-4xl font-bold mb-2 text-center">
              {t("withDraw.youEarnedIt")}
            </h1>
            <p className="text-[#333333] text-4xl font-bold mb-4 text-center">
              $
              {withdrawDetails?.data?.transaction_fee > 0
                ? withdrawDetails?.data?.receive_amount.toFixed(2)
                : (withdrawDetails?.data?.receive_amount - 0.5).toFixed(2)}
            </p>
            <p className="text-[#A0A0A0] text-sm font-medium text-center mb-2 max-w-[280px]">
              {t("withDraw.allow3WorkingDayForWithdraw")}
            </p>

            <div className="flex flex-col items-center w-full max-w-[376px]">
              <Button
                text={t("withDraw.backToProfile")}
                onClick={handleBackToProfile}
                className="bg-[#253FF6] text-white font-medium text-lg rounded-md h-[50px] mb-4 w-full"
              />

              <button
                onClick={handleWithdrawalHistory}
                className="text-[#A0A0A0] text-base font-medium underline"
              >
                {t("historyWithdraw.withdrawHistory")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EarningWithdraw;
